// Campanhas — lista + funil (kanban) + criação/disparo (API real).
// Fala com /clinica/campaigns. Adapter no front (stage en→pt, presentation,
// funil selected/sent/... → selecionados/enviada/...). Disparo usa Zenvia no back.
import AXIOS from "@/services/axios";
import { initialsOf, avatarClassFor } from "./helpers";

const STAGE_PT = {
  draft: "rascunho",
  running: "em_andamento",
  done: "concluida"
};
const STATUS_LABEL = {
  draft: "Rascunho",
  running: "Em andamento",
  done: "Concluída"
};

function adaptCampaign(c) {
  return {
    id: c.id,
    name: c.name,
    audienceCount: c.audience_count,
    stage: STAGE_PT[c.stage] || c.stage,
    status: STATUS_LABEL[c.stage] || c.stage,
    sent: c.sent_count,
    returns: c.scheduled_count,
    conversion: c.conversion
  };
}

function adaptFunnelItems(items) {
  return (items || []).map((t, i) => ({
    patientId: t.patient_id,
    name: t.name,
    initials: initialsOf(t.name),
    avatarClass: avatarClassFor(i),
    meta: ""
  }));
}

export class ClinicCampaigns {
  static list() {
    return AXIOS.get("clinica/campaigns").then(({ data }) => ({
      data: (data || []).map(adaptCampaign)
    }));
  }

  static funnel() {
    return AXIOS.get("clinica/campaigns/funnel").then(({ data }) => ({
      data: {
        selecionados: adaptFunnelItems(data.selected),
        enviada: adaptFunnelItems(data.sent),
        respondeu: adaptFunnelItems(data.responded),
        agendado: adaptFunnelItems(data.scheduled)
      }
    }));
  }

  static create(payload) {
    return AXIOS.post("clinica/campaigns", {
      name: payload.name,
      message: payload.message,
      audience: payload.audience || []
    }).then(({ data }) => ({ data: adaptCampaign(data) }));
  }

  // Encerra a campanha (running → done) — decisão manual do staff.
  static finish(id) {
    return AXIOS.post(`clinica/campaigns/${id}/finish`).then(({ data }) => ({
      data: adaptCampaign(data)
    }));
  }

  // Dispara a campanha (WhatsApp+SMS via Zenvia no backend) e avança o funil.
  static send(id) {
    return AXIOS.post(`clinica/campaigns/${id}/send`).then(({ data }) => ({
      data: adaptCampaign(data)
    }));
  }
}

export default ClinicCampaigns;
